import { render, staticRenderFns } from "./AnotherPlate.vue?vue&type=template&id=420544ac&scoped=true&"
import script from "./AnotherPlate.vue?vue&type=script&lang=js&"
export * from "./AnotherPlate.vue?vue&type=script&lang=js&"
import style0 from "./AnotherPlate.vue?vue&type=style&index=0&id=420544ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420544ac",
  null
  
)

component.options.__file = "AnotherPlate.vue"
export default component.exports